import { render } from "./AllSubServices.vue?vue&type=template&id=5ba75c73&scoped=true"
import script from "./AllSubServices.vue?vue&type=script&lang=js"
export * from "./AllSubServices.vue?vue&type=script&lang=js"

import "./AllSubServices.vue?vue&type=style&index=0&id=5ba75c73&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba75c73"]])

export default __exports__